export const QipFeaturedImageText = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="relative py-60 bg-[#F6F6F6] [clip-path:polygon(0_15vw,100%_0,100%_calc(100%-15vw),0_100%)] px-6 font-sans text-[#333]">
      <div className="max-w-[950px] mx-auto flex flex-col gap-20 md:gap-32">
        {items.map((item, index) => {
          return (
            <div
              key={index}
              className="flex flex-col items-center justify-between gap-10 lg:gap-20 flex-wrap md:flex-row"
            >
              {/* Text Block */}
              <div className="flex-1 w-full">
                <h2 className="text-4xl font-semibold text-gray mb-5 tracking-tight">
                  {item.headline}
                </h2>
                <div
                  className="prose max-w-none [&_p]:text-base text-gray-600 leading-relaxed [&>p]:mb-4 last:[&>p]:mb-0 [&>p>strong]:text-gray-900 [&>p>strong]:font-bold"
                  dangerouslySetInnerHTML={{ __html: item.copy }}
                />
              </div>

              {item.featured_image && (
                <img
                  src={item.featured_image}
                  alt={item.headline}
                  className="max-w-full h-auto max-h-[350px] lg:max-w-[350px] object-contain"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
